<template>
    <!-- Modal -->
    <div class="modal fade" id="edit" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <Head title="ثبت اطلاعات جسمانی"/>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content modal__wrist">
                <div class="modal-header">
                    <h5 class="modal-title text-title" id="exampleModalLabel">وزن خود را ویرایش کنید</h5>
                    <button type="button" class="btn-close d-inline-block p-0 m-0 me-auto" data-bs-dismiss="modal"
                            ref="btnClose" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="store">
                        <input class="my-3 form-control text-md py-4" type="text" v-model="form.targetWeight"
                               name="weight" placeholder="وزن (kg)">
                        <div v-if="form.errors.targetWeight" class="form-error">
                            <p class="m-0 text-sm text-error mb-3">{{ form.errors.targetWeight }}</p>
                        </div>

                        <div class="mt-5 text-center">
                            <button :loading="form.processing" :disabled="form.processing" class="btn btn-orange"
                                    type="submit">
                                <span v-if="form.processing" class="spinner-border spinner-border-sm" role="status"
                                      style="width: 1.5rem; height: 1.5rem;" aria-hidden="true"></span>
                                <span v-else>ثبت</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="container mt-nav z-index">
        <div class="row">
            <div class="col-sm-10 col-lg-7 mx-auto">
                <div class="box__information">
                    <div class="col-12 col-md-10 pb-5 px-0 px-sm-3">
                        <p class="text-title text-white text-center pb-3">شاخص توده بدنی شما هم اکنون <span class="text-green">{{ bmi['BMI'] }}</span> می باشد</p>
                        <div class="ruler">
                            <div class="position-relative" :class="{active : bodyTypeNumber === 1}">
                                <p class="m-0 text-sm text-gray mx-1 mx-sm-2"> کمبود وزن</p>
                            </div>
                            <div class="position-relative" :class="{active : bodyTypeNumber === 2}">
                                <p class="m-0 text-sm text-gray mx-1 mx-sm-2"> نرمال و ایده آل</p>
                            </div>
                            <div class="position-relative" :class="{active : bodyTypeNumber === 3}">
                                <p class="m-0 text-sm text-gray mx-1 mx-sm-2"> اضافه وزرن</p>
                            </div>
                            <div class="position-relative mx-1" :class="{active : bodyTypeNumber === 4}">
                                <p class="m-0 text-sm text-gray">چاقی</p>
                            </div>
                            <div class="position-relative" :class="{active : bodyTypeNumber > 4}">
                                <p class="m-0 text-sm text-gray mx-2 mx-sm-2">چاقی درجه 2</p>
                            </div>
                        </div>
                    </div>
                    <div class="my-4 my-sm-5">
                        <p class="text-md text-light">
                            وزن مناسب شما بین {{bmi['START_RANGE']}} تا {{bmi['END_RANGE']}} کیلوگرم میباشد. شما میتوانید خودتان وزن هدف را مشخص کنید
                        </p>
                    </div>

                    <div v-if="$page.props.flash.success" class="alert alert-custom" role="alert">
                        {{ $page.props.flash.success }}
                    </div>

                    <div class="text__information mt-0 mt-sm-4">
                        <div>
                            <p class="m-0 text-light text-md">زمان رسیدن به وزن ایده‌آل</p>
                            <div class="dashed"></div>
                            <p class="m-0 text-light text-md">{{ bmi['Time_to_target_weight'] * 7 }} روز دیگر</p>
                        </div>
                        <div>
                            <p class="m-0 text-light text-md"
                               v-text="bmi['typeWeight'] === 1 ? 'میزان اضافه وزن' : 'میزان کمبود وزن'"></p>
                            <div class="dashed"></div>
                            <p class="m-0 text-light text-md">{{ bmi['EZAFE_VAZN_result'].toFixed(2) }} کیلو گرم</p>
                        </div>
                        <div class="position-relative ps-5 ps-sm-0">
                            <p class="m-0 text-light text-md">وزن مناسب شما</p>
                            <div class="dashed"></div>
                            <p class="m-0 text-light text-md active">{{ bmi['CURRECT_VAZN'] }} کیلوگرم</p>
                            <button ref="btnOpen" class="btn text-md text-orange edit__modal"
                                    data-bs-toggle="modal" data-bs-target="#edit">تغییر</button>
                        </div>
                        <div>
                            <p class="m-0 text-light text-md">تعداد رژیم مورد نیاز</p>
                            <div class="dashed"></div>
                            <p class="m-0 text-light text-md">{{ bmi['Time_to_target_weight'] }} رژیم</p>
                        </div>
                    </div>

                    <div class="text-center mt-2 w-100">
                        <div class="row">
                            <div class="col-12" v-if="status === 'insert'">
                                <Link class="btn btn-orange hide-box" href="/consulting">ادامه مراحل و دریافت رژیم</Link>
                            </div>
                            <div class="col-12 mt-3" v-if="backToProfile">
                                <a class="btn btn-orange hide-box w-50" href="/profile">بازگشت به پروفایل</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "../Shared/Layouts/LayoutFirstRegister";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    props: ['bmi', 'bodyInformation', 'auth', 'editTargetWeight' , 'status'],
    components: {
        Head, Link
    },
    layout: LayoutFirstRegister,
    data() {
        return {
            backToProfile: false,
            form: this.$inertia.form({
                targetWeight: '',
                action: this.status,
            }),
            bodyTypeNumber: 2,
        }
    },
    mounted() {
        if (this.editTargetWeight === true) {
            this.$refs.btnOpen.click();
        }

        if (this.auth.user) {
            this.backToProfile = true;
        }
        this.bodyTypeNumber = this.bmi['bodyTypeNumber'];
        this.form.targetWeight = this.bmi['CURRECT_VAZN'];
    },
    watch: {
        '$page.props.flash': {
            handler() {
                this.$refs.btnClose.click();
            },
            deep: true,
        },
    },
    methods: {
        store() {
            this.form.post('/bmi');
        },
    },
    metaInfo() {
        return {
            meta: [
                { name: 'description', content: 'hello is my desd' }
            ]
        }
    }
}
</script>

<style scoped>
/* Add your styles here */
</style>
